import { useEffect, useState } from 'react';
import {
  getInteractionApi,
  subscribeToInteractionApiAvailability
} from 'src/utils/five9/subscribeToInteractionApi';

/**
 * Returns whether the current tab owns a live Five9 interaction API.
 */
export default function useIsFive9ActiveInTab() {
  const [isActive, setIsActive] = useState(() => Boolean(getInteractionApi()));
  useEffect(() => {
    // Re-sync: availability may have changed between render and subscription.
    setIsActive(Boolean(getInteractionApi()));
    return subscribeToInteractionApiAvailability((api) => setIsActive(Boolean(api)));
  }, []);
  return isActive;
}
